<template>
	<app-page>
		<app-heading title="My Notifications">
			<template v-slot:right>
				<app-button
					color="secondary"
					icon="fa-check-double"
					outlined
					small
					:loading="readingAll"
					@click="onReadAll"
				>Mark all as read</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="notifications"
					:headers="headers"
					:total="count"
					:sort-by="'_id'"
					:sort-desc="true"
					:refresh.sync="refresh"
					:initial-state="tableState"
					@update="fetchNotifications"
				>
					<template v-slot:read="{ item }">
						<app-icon
							:icon="item.read ? 'far fa-circle' : 'fa-circle'"
							size="12"
						/>
					</template>
					<template v-slot:actions="{ item }">
						<app-button
							table
							color="secondary"
							icon="fa-envelope-open"
							:to="{
								name: 'my-notification',
								params: { notification: item._id },
							}"
						>Read</app-button>
						<app-button
							table
							color="secondary"
							:disabled="item.read"
							@click="onMarkAsRead(item._id)"
							icon="fa-check"
						>Mark as read</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
import tableState from '@/mixins/tablestate'

export default {
	mixins: [tableState],
	data() {
		return {
			headers: [{
				text: '',
				value: 'read',
				sortable: false,
			}, {
				text: 'Date/Time',
				value: '_id',
				sortable: true,
				format: 'datetime',
				formatArgs: [true],
			}, {
				text: 'Title',
				value: 'title',
				sortable: false,
			}, {
				text: 'Subject',
				value: 'subject',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			notifications: [],
			count: -1,
			refresh: false,
			readingAll: false,
			socket: null,
			defaultTableSort: '-_id',
		}
	},

	mounted() {
		this.socket = this.$ravello.socket('notifications')
	},

	methods: {
		async fetchNotifications(pagination) {
			this.updateTableState(pagination)
			const query = this.$ravello.request().me()
				.to('notifications')
				.fromPagination(pagination)

			/*
			if (typeof read !== 'undefined') {
				query.param('read', read)
			} */

			this.notifications = await query.get()

			if (this.count === -1) {
				const count = await query.count()
				this.count = count.count
			}
		},

		async onMarkAsRead(id) {
			await this.$ravello.request().me()
				.to('notifications')
				.to(id)
				.to('read')
				.create()

			this.refresh = true
			this.socket.emit('read', id)
		},

		async onReadAll() {
			this.readingAll = true
			await this.$ravello.request().me()
				.to('notifications')
				.to('read')
				.create()

			this.refresh = true
			this.readingAll = false
			this.socket.emit('readAll')
		},
	},
	beforeDestroy() {
		if (this.socket) {
			this.socket.disconnect()
		}
	},
}
</script>
